// src/features/modal/SelectOfficialModal.jsx
import React, { useState } from "react";
import GovtOfficial from "../../Images/Govt. Official.png";
import ServiceProvider from "../../Images/Service Provider.png";
import { useNavigate } from "react-router-dom";
import TempLoginModal from "./TempLoginModal";

export default function SelectOfficialModal({ isOpen, onClose }) {
  const [tempModalLoginOpen, setTempLoginModalOpen] = useState(false);
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="
          bg-white p-8 
          w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-2/5 
          max-h-[90vh] overflow-auto 
          relative
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-6 text-center">
          Please Select User Type to continue
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Card 1 */}
          <div
            className="flex flex-col items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-100"
            onClick={() => setTempLoginModalOpen(true)}
          >
            <div className="w-24 h-24 bg-sky-100 rounded-full flex items-center justify-center mb-2">
              <img
                src={ServiceProvider}
                alt="Service Provider"
                className="w-20 h-20"
              />
            </div>
            <span className="font-medium">1. Service Provider</span>
          </div>

          {/* Card 2 */}
          <div
            className="flex flex-col items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-100"
            onClick={() => navigate("/GovtOfficialForm")}
          >
            <div className="w-24 h-24 border rounded-full flex items-center justify-center mb-2">
              <img
                src={GovtOfficial}
                alt="Legal Entity"
                className="w-20 h-20"
              />
            </div>
            <span className="font-medium">2. Government Official</span>
          </div>
        </div>
      </div>
      {tempModalLoginOpen && (
        <TempLoginModal
          isOpen={tempModalLoginOpen}
          onClose={() => setTempLoginModalOpen(false)}
        />
      )}
    </div>
  );
}
